import { utilityMutations } from '@v/Core/Global/Store/utility'

export const state = {
    staff: {},
    divisions: {},
    configs: {},
    locations: {},
    currentStaff: null,
    locationFilter: 0,
    divisionFilter: 0
}

export const getters = {
    getDivisions: (state) => (idArr) => {
        return idArr.map(id => state.divisions[id]);
    },
    getLocations: (state) => (idArr) => {
        return idArr.map(id => state.locations[id]);
    },
    currentStaffGetProperty: (state) => (prop) => {
        if (!state.currentStaff || !state.staff[state.currentStaff] || !state.staff[state.currentStaff][prop]) return;
        return state.staff[state.currentStaff][prop];
    },
    locationsWithStaff: (state) => {
        let obj = {};
        Object.entries(state.locations).forEach(([locKey, locVal]) => {
            let ids = [];
            obj[locKey] = { ...locVal };
            Object.entries(state.staff).forEach(([staKey, staVal]) => {
                staVal.locations.includes(Number(locKey)) && !ids.includes(Number(staKey)) && (ids.push(Number(staKey)));
            })
            obj[locKey].staff = [...new Set(ids)];
        })
        return obj;
    },
    getFilteredStaff: (state, getters) => {
        let s  = state.staff,
            d  = state.divisions,
            df = state.divisionFilter,
            l  = getters.locationsWithStaff,
            lf = state.locationFilter,
            ids = [];

        if (!df && !lf) ids = Object.keys(s);
        else if (!lf) ids = d[df].staff;
        else if (!df) ids = l[lf].staff;
        else ids = [...new Set(d[df].staff.filter(id => l[lf].staff.includes(id)))].sort((a,b)=>a-b);

        ids.sort((a,b) => s[a].sort_id - s[b].sort_id);

        return ids.map(id => state.staff[id]);
    }
}

export const mutations = {
    ...utilityMutations,
}

export const actions = {
    currentStaffSet (context, id) {
        context.commit('SET', ['currentStaff', id])
    },
    currentStaffReset (context) {
        context.commit('SET', ['currentStaff', null])
    }
}

export default { namespaced: true, state, getters, mutations, actions };